import React from "react";
import { KopHeader, TTDBlock } from "./PrintHeader";

export default function PrintCatatanSiku({ settings = {}, siswa = {}, rangking, catatan_siku = [], periode = {}, showSignature = true }) {
  return (
    <div className="print-doc bg-white text-black mx-auto" style={{ width: "200mm", padding: "10mm 12mm", boxShadow: "0 0 8px rgba(0,0,0,0.08)", fontFamily: "Arial, sans-serif", fontSize: "11pt" }}>
      <KopHeader line1={settings.kop_l1} line2={settings.kop_l2} />

      <div style={{ textAlign: "center", margin: "16px 0 14px" }}>
        <div style={{ fontWeight: "bold", letterSpacing: 1 }}>CATATAN SIKU PERORANGAN</div>
      </div>

      <table style={{ marginBottom: 12, border: "none", width: "100%" }}>
        <tbody>
          <tr>
            <td style={{ border: "none", width: 130, padding: "1px 4px" }}>Pendidikan</td>
            <td style={{ border: "none", width: 10, padding: "1px 0" }}>:</td>
            <td style={{ border: "none", padding: "1px 4px" }}>{settings.pendidikan}</td>
            <td style={{ border: "none", padding: "1px 4px", width: 90, textAlign: "right" }}>{periode.jenis === "bulanan" ? "Bulanan ke" : "Mingguan ke"}</td>
            <td style={{ border: "none", padding: "1px 0", width: 10 }}>:</td>
            <td style={{ border: "none", padding: "1px 4px", width: 80, fontWeight: "bold" }}>{periode.nomor ?? "—"}</td>
          </tr>
          <tr>
            <td style={{ border: "none", padding: "1px 4px" }}>Periode Penilaian</td>
            <td style={{ border: "none", padding: "1px 0" }}>:</td>
            <td style={{ border: "none", padding: "1px 4px" }}>{periode.bulan || settings.bulan} {periode.tahun || settings.tahun}</td>
          </tr>
          <tr>
            <td style={{ border: "none", padding: "1px 4px" }}>Nama</td>
            <td style={{ border: "none", padding: "1px 0" }}>:</td>
            <td style={{ border: "none", padding: "1px 4px", fontWeight: "bold" }}>{siswa.nama}</td>
          </tr>
          <tr>
            <td style={{ border: "none", padding: "1px 4px" }}>Nosis/No AK/NIM</td>
            <td style={{ border: "none", padding: "1px 0" }}>:</td>
            <td style={{ border: "none", padding: "1px 4px" }}>{siswa.nosis}</td>
          </tr>
          {rangking != null && (
            <tr>
              <td style={{ border: "none", padding: "1px 4px" }}>Rangking</td>
              <td style={{ border: "none", padding: "1px 0" }}>:</td>
              <td style={{ border: "none", padding: "1px 4px", fontWeight: "bold" }}>{rangking}</td>
            </tr>
          )}
        </tbody>
      </table>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ width: 32, textAlign: "center" }}>NO</th>
            <th style={{ textAlign: "center" }}>INDIKATOR PENILAIAN</th>
            <th style={{ width: 52, textAlign: "center" }}>KODE</th>
            <th style={{ width: 56, textAlign: "center" }}>JML OBS</th>
            <th style={{ width: 56, textAlign: "center" }}>HASIL OBS</th>
            <th style={{ width: 44, textAlign: "center" }}>SKOR</th>
          </tr>
          <tr>
            <th style={{ textAlign: "center" }}>1</th>
            <th style={{ textAlign: "center" }}>2</th>
            <th style={{ textAlign: "center" }}>3</th>
            <th style={{ textAlign: "center" }}>4</th>
            <th style={{ textAlign: "center" }}>5</th>
            <th style={{ textAlign: "center" }}>6</th>
          </tr>
        </thead>
        <tbody>
          {catatan_siku.map((c) => (
            <tr key={c.no} style={c.no >= 50 ? { background: "#f7faf7" } : {}}>
              <td style={{ textAlign: "center" }}>{c.no}</td>
              <td style={{ textAlign: "left", fontSize: "10pt", lineHeight: 1.3 }}>{c.teks}</td>
              <td style={{ textAlign: "center", fontWeight: "bold" }}>{c.kode}</td>
              <td style={{ textAlign: "center" }}>{c.jml_obs}</td>
              <td style={{ textAlign: "center" }}>{c.hasil_obs}</td>
              <td style={{ textAlign: "center", fontWeight: "bold" }}>{c.skor}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {showSignature && (
        <TTDBlock
          lokasi={settings.lokasi}
          bulan={(periode && periode.bulan) || settings.bulan}
          tahun={(periode && periode.tahun) || settings.tahun}
          jabatan={settings.jabatan_penandatangan}
          nama={settings.nama_komandan}
          pangkat={settings.pangkat_komandan}
          nrp={settings.nrp_komandan}
        />
      )}
    </div>
  );
}
